import styles from './ForgotPasswordSuccess.module.scss';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import { IMAGES } from '@/constants/ui/images';

export const ForgotPasswordSuccess: React.FC = () => {
  return (
    <div className={styles.successWrapper}>
      <PublicImage src={`${IMAGES.PATHS.MISC}/you-got-mail.svg`} alt="mail" />
    </div>
  );
};
